export const ADD_IMPACT_MIN_CARBON_REMOVAL_TONNES = 0.1;
export const ADD_IMPACT_MIN_HABITAT_RESTORATION_METERS = 0.1;
